// extracted by mini-css-extract-plugin
module.exports = {"radio-item":"versionList-m__radio-item__3aQWP","version-list":"versionList-m__version-list__30AFr","current-version":"versionList-m__current-version__fjJsJ"};